import React from 'react';
import { ILuxeMenuTab } from '../MenuLUXE';
import { EzypayTextContainer, FooterButtonBlack, FooterButtonContainer, FooterButtonWhite, MenuFooterContainer, MenuFooterInnerContainer, PriceContainer, ShippingTextContainer } from './MenuFooter-styled';


interface Props {
  price:number,
  tabs:ILuxeMenuTab[],
  currentMenuTab:number,
  onTabSelect:(current:number)=>void,
  onCheckout:()=>void,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

export class MenuFooter extends React.Component<Props,{}> {
  constructor(props) {
    super(props)
  }

  public getButtons = () => {
    const { tabs, currentMenuTab, onTabSelect, onCheckout } = this.props;
    let buttons;

    const prevStep = () => {
      onTabSelect(currentMenuTab-1);
    }

    const nextStep = () => {
      onTabSelect(currentMenuTab+1);
    }

    if (currentMenuTab === 0) {
      buttons = (
        <FooterButtonContainer>
          <FooterButtonWhite inactive>PREV STEP</FooterButtonWhite>
          <FooterButtonBlack onClick={nextStep}>NEXT STEP</FooterButtonBlack>
        </FooterButtonContainer>
      )
    } else if (currentMenuTab+1 === tabs.length) {
      buttons = (
        <FooterButtonContainer>
          <FooterButtonWhite onClick={prevStep}>PREV STEP</FooterButtonWhite>
          <FooterButtonBlack onClick={onCheckout}>BUY NOW</FooterButtonBlack>
        </FooterButtonContainer>
      )
    } else {
      buttons = (
        <FooterButtonContainer>
          <FooterButtonWhite onClick={prevStep}>PREV STEP</FooterButtonWhite>
          <FooterButtonBlack onClick={nextStep}>NEXT STEP</FooterButtonBlack>
        </FooterButtonContainer>
      )
    }

    return buttons;
  }

  public render = () => {
    const { price, mobile, menuHeight, menuScaleFactor } = this.props;

    const footerButtons = this.getButtons();

    return (
      <MenuFooterContainer className="threed-configurator-menu-footer" mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <MenuFooterInnerContainer>
          {!mobile && <PriceContainer>${price.toLocaleString('en-US')}</PriceContainer>}
          {/* <EzypayTextContainer>or 4 interest-free installments of $3,000.00 by [EZYPAY]</EzypayTextContainer> */}
          {footerButtons}
          {/* <ShippingTextContainer>FREE WORLDWIDE DHL SHIPPING</ShippingTextContainer> */}
        </MenuFooterInnerContainer>
      </MenuFooterContainer>
    )
  }
}